import { apiGet, apiPost, apiPut } from '@jumbo/utils/ApiHelper';
import config from 'config';
const apiUrl = config.apiUrl;
const loadApiUrl = config.loadApiUrl;

export function getCitiesApi(search = '') {
  if (search && search.length) {
    return apiGet(apiUrl, `/cities/${search}`);
  } else {
    return apiGet(apiUrl, '/cities');
  }
}
export function getUsersApi(data) {
  return apiGet(apiUrl, 'admin/api/users', data);
}

export function getAdminUserByAdminIdApi(id) {
  return apiGet(apiUrl, `admin/api/admin-user/${id}`);
}

export function getAdminUsersApi(data) {
  return apiGet(apiUrl, 'admin/api/admin-users', data);
}

export function SearchUserApi(data) {
  return apiGet(apiUrl, 'admin/api/users/search', data);
}

export function getOnboardingDataApi(data) {
  return apiGet(apiUrl, 'admin/api/onboarding', data);
}

export function updateOnboardingDataApi(data, userId) {
  return apiPut(apiUrl, `admin/api/onboarding/${userId}`, data);
}

export function getPreferencesApi() {
  return apiGet(apiUrl, 'users/sync/preferences');
}

export function getAdminRolesApi(data) {
  return apiGet(apiUrl, 'admin/api/roles', data);
}

export function getPermissionsApi() {
  return apiGet(apiUrl, 'admin/api/roles/permissions');
}

export function addNewAdminRoleAPI(payload) {
  if (payload.id) {
    return apiPut(apiUrl, `admin/api/roles?role_id=${payload.id}`, payload);
  } else {
    return apiPost(apiUrl, `admin/api/roles`, payload);
  }
}

export function addNewAdminUserAPI(payload) {
  if (payload.id) {
    return apiPut(apiUrl, `admin/api/admin-users?id=${payload.id}`, payload);
  } else {
    return apiPost(apiUrl, `admin/api/register`, payload);
  }
}

export function getUsersByIdsListApi(data) {
  return apiPost(apiUrl, 'users/list_details', data);
}

export function getCarrierRepsListApi(data) {
  return apiGet(loadApiUrl, 'dispatches/carrier-reps/list');
}

export function getUserProfileInfoApi(user_id) {
  return apiGet(apiUrl, `admin/api/users/${user_id}`);
}